import { cn } from '@/utils/style';
import MailChatBubbleOvalCheck from '../../../../public/images/medicine-dictionary/mailChatBubbleTypingOval.svg';

interface Props {
  simplifiedName?: string;
  formattedIngredientName?: string;
  ethicalType?: string;
  companyName?: string;
}

const MedicineBasicInfo = (props: Props) => {
  return (
    <section className={cn('flex flex-col gap-[20px] px-[24px] py-[28px]')}>
      <div className='flex items-center gap-[8px]'>
        <MailChatBubbleOvalCheck className='shrink-0' />
        <h2 className='typography-ui-19sb shrink-1 select-text text-gray-700'>
          {props.simplifiedName}, 어떤 약인가요?
        </h2>
      </div>
      <div className='flex flex-col gap-[2px]'>
        <div className='flex items-center gap-[10px]'>
          <h3 className='typography-ui-15m flex-shrink-0 select-text text-gray-400'>성분</h3>
          <span className='typography-ui-15r flex-shrink-1 select-text text-gray-900'>
            {props.formattedIngredientName}
          </span>
        </div>
        <div className='flex items-center gap-[10px]'>
          <h3 className='typography-ui-15m flex-shrink-0 select-text text-gray-400'>구분</h3>
          <span className='typography-ui-15r flex-shrink-1 select-text text-gray-900'>{props.ethicalType}</span>
        </div>
        <div className='flex items-center gap-[10px]'>
          <h3 className='typography-ui-15m flex-shrink-0 select-text text-gray-400'>업체</h3>
          <span className='typography-ui-15r flex-shrink-1 select-text text-gray-900'>{props.companyName}</span>
        </div>
      </div>
    </section>
  );
};

export default MedicineBasicInfo;
